import { toast } from "react-toastify";

import { http } from '../../http';
import * as actionTypes from "../actionTypes";
import { GetTopFitnessLeaderboardData, GetTopSocialUsers, GetTopFitnessUsers, GetTopWellnessUsers, GetTopUserTotalPoints, GetUserPointsRank, GetCompanyTotalTeamPoints, GetTotalTeamUsersPoints, GetTeamIcons, AddOrUpdateTeamDetails, GetCompanyTeamCount, GetCompanyTeamAndMyTeamFlags, GetUserLeaderboardPoints,FetchTopFitnessLeaderboardData, FetchTopUserTotalPoints,FetchUserPointsRank,FetchCompanyTotalTeamPoints,FetchUserLeaderboardPoints,FetchTopFitnessUsers,FetchTopSocialUsers,FetchTopWellnessUsers,FetchTotalTeamUsersPoints } from "../../constants/apiConstants";

const networkError = (error) => (dispatch) => dispatch({ type: actionTypes.NETWORK_ERROR, networkError: error });

const getTopFitnessLeaderboard = (id,pageNumber, limit,isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      let url = "";
      if (isNewReward) {
        url = `${FetchTopFitnessLeaderboardData}?company_id=${id}&page=${pageNumber}&limit=${limit}`;
      } else {
        url = `${GetTopFitnessLeaderboardData}/${id}/${pageNumber}/${limit}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });

      window.console.log("res isNewReward",isNewReward)
      window.console.log("res for leaderboard",res)
      // const res = await http.get(`${GetTopFitnessLeaderboardData}/${id}/${pageNumber}/${limit}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.FITNESS_LEADERBOARD_DATA, fitnessLeaderboard: res, pageNumber: pageNumber, distanceLeaderboard: res['distance'], stepsLeaderboard: res['steps'], caloriesLeaderboard: res['calories'] });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const getTopSocialUsers = (id,pageNumber, limit, isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {

      let url = "";
      if (isNewReward) {
        url = `${FetchTopSocialUsers}?company_id=${id}&page=${pageNumber}&limit=${limit}`;
      } else {
        url = `${GetTopSocialUsers}/${id}/${pageNumber}/${limit}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });

      // const res = await http.get(`${GetTopSocialUsers}/${id}/${pageNumber}/${limit}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.SOCIAL_USERS_DATA,pageNumber: pageNumber, socialUserData: res[0] });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const getTopFitnessUsers = (id,pageNumber, limit,isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      let url = "";
      if (isNewReward) {
        url = `${FetchTopFitnessUsers}?company_id=${id}&page=${pageNumber}&limit=${limit}`;
      } else {
        url = `${GetTopFitnessUsers}/${id}/${pageNumber}/${limit}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });

      // const res = await http.get(`${GetTopFitnessUsers}/${id}/${pageNumber}/${limit}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.FITNESS_USERS_DATA,pageNumber: pageNumber, fitnessUserData: res[0] });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const getTopWellnessUsers = (id,pageNumber, limit, isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {

      let url = "";
      if (isNewReward) {
        url = `${FetchTopWellnessUsers}?company_id=${id}&page=${pageNumber}&limit=${limit}`;
      } else {
        url = `${GetTopWellnessUsers}/${id}/${pageNumber}/${limit}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });

      // const res = await http.get(`${GetTopWellnessUsers}/${id}/${pageNumber}/${limit}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.WELLNESS_USERS_DATA,pageNumber: pageNumber, wellnessUserData: res[0] });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const getTopUserTotalPoints = (id,pageNumber, limit, isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      let url = "";
      if (isNewReward) {
        url = `${FetchTopUserTotalPoints}?company_id=${id}&page=${pageNumber}&limit=${limit}`;
      } else {
        url = `${GetTopUserTotalPoints}/${id}/${pageNumber}/${limit}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });
      // const res = await http.get(`${GetTopUserTotalPoints}/${id}/${pageNumber}/${limit}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.TOP_USER_TOTAL_POINTS,pageNumber: pageNumber, topUsersTotalPoints: res[0] });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const getCompanyTotalTeamPoints = (id,pageNumber, limit, isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      let url = "";
      if (isNewReward) {
        url = `${FetchCompanyTotalTeamPoints}?company_id=${id}&page=${pageNumber}&limit=${limit}`;
      } else {
        url = `${GetCompanyTotalTeamPoints}/${id}/${pageNumber}/${limit}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });

      window.console.log("res for company team points",res)

      // const res = await http.get(`${GetCompanyTotalTeamPoints}/${id}/${pageNumber}/${limit}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.COMPANY_TEAM_POINTS,pageNumber: pageNumber, companyTeamPoints: res });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const getTotalTeamUsersPoints = (isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {

      let url = "";
      if (isNewReward) {
        url = `${FetchTotalTeamUsersPoints}`;
      } else {
        url = `${GetTotalTeamUsersPoints}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });

      // const res = await http.get(`${GetTotalTeamUsersPoints}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.TEAM_USERS_POINTS, teamUsersPoints: res });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const fetchTeamIcons = () => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      const res = await http.get(`${GetTeamIcons}`, {headers: { AUTHTOKEN: AuthToken }});
      if (res.message) {
        toast.error(res.message);
      }else{
        dispatch({type: actionTypes.TEAM_ICONS, teamIconsData: res});
      }
    }catch(error){
      toast.error(error.message);
      dispatch(networkError(error.message));
    }
  }
};

const fetchCompanyTeamsCount = (id) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      const res = await http.get(`${GetCompanyTeamCount}/${id}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        // toast.error(res.message);
      }else{
        dispatch({type: actionTypes.GET_COMPANY_TEAM_COUNT, teamsCount: res});
        // dispatch(FetchEmployeeCount(id))
      }
    }catch(error){
      toast.error(error.message);
      dispatch(networkError(error.message));
    }
  }
};

const fetchCompanyTeamAndMyTeamFlags = (id) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      const res = await http.get(`${GetCompanyTeamAndMyTeamFlags}/${id}`, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        // toast.error(res.message);
      }else{
        dispatch({type: actionTypes.GET_COMPANY_TEAM_AND_MY_TEAM_FLAGS, wellnessCount: res});
      }
    }catch(error){
      toast.error(error.message);
      dispatch(networkError(error.message));
    }
  }
};

const fetchAddOrUpdateTeamsDetails = (obj,isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      const res = await http.post(AddOrUpdateTeamDetails, obj, {headers: {AUTHTOKEN: AuthToken}});
      if (res.message) {
        toast.error(res.message);
      }else{
        toast.success(res[0]);
        // window.location.reload();
        if(isNewReward){
          dispatch(getTotalTeamUsersPoints(isNewReward));
        }else{
          dispatch(getTotalTeamUsersPoints())
        }
      }
    }catch(error){
      toast.error(error.message);
      dispatch(networkError(error.message));
    }
  }
};


const getCompanyRank = (id,isNewReward) => {
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      let url = "";
      if (isNewReward) {
        url = `${FetchUserPointsRank}?company_id=${id}`;
      } else {
        url = `${GetUserPointsRank}/${id}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });


      // const res = await http.get(`${GetUserPointsRank}/${id}`, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.USER_RANK, userRank: res });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

const fetchLeaderboardAPI = (id,pageNumber, limit,isNewReward) => (dispatch) => {
  dispatch(getTopFitnessLeaderboard(id, pageNumber, limit,isNewReward));
  dispatch(getTopSocialUsers(id, pageNumber, limit,isNewReward));
  dispatch(getTopFitnessUsers(id, pageNumber, limit,isNewReward));
  dispatch(getTopWellnessUsers(id, pageNumber, limit,isNewReward));
  dispatch(getTopUserTotalPoints(id, pageNumber, limit,isNewReward));
  dispatch(getCompanyTotalTeamPoints(id, pageNumber, limit,isNewReward));
  dispatch(getTotalTeamUsersPoints(isNewReward));
  dispatch(fetchTeamIcons());
  dispatch(fetchCompanyTeamsCount(id));
  dispatch(fetchCompanyTeamAndMyTeamFlags(id));
}

const setCompany = (id, name, companyStartDate, showBiometricStatus) => (dispatch) => {
  dispatch({type: actionTypes.SET_COMPANY, id, name, companyStartDate, showBiometricStatus});
};

const getUserLeaderboardPoints = (isNewReward) => {
  window.console.log("isNewReward",isNewReward)
  const AuthToken = localStorage.getItem('AUTH_TOKEN');
  return async (dispatch) => {
    try {
      let url = "";
      if (isNewReward) {
        url = `${FetchUserLeaderboardPoints}`;
      } else {
        url = `${GetUserLeaderboardPoints}`;
      }
      const res = await http.get(url, {
        headers: { AUTHTOKEN: AuthToken }
      });
      window.console.log("res for user leaderboard points",res)
      // const res = await http.get(GetUserLeaderboardPoints, { headers: { AUTHTOKEN: AuthToken } });
      if (res.message) {
        toast.error(res.message);
      } else {
        dispatch({ type: actionTypes.USER_TOTAL_POINTS, userTotalPoints: res });
      }
    } catch (error) {
      dispatch(networkError(error.message));
    }
  }
};

export { getTopFitnessLeaderboard, getTopSocialUsers, getTopFitnessUsers, getTopWellnessUsers, fetchLeaderboardAPI, getTopUserTotalPoints, setCompany, getCompanyRank, getCompanyTotalTeamPoints, getTotalTeamUsersPoints, fetchTeamIcons, fetchAddOrUpdateTeamsDetails, fetchCompanyTeamsCount, fetchCompanyTeamAndMyTeamFlags, getUserLeaderboardPoints };

